import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestAuthAPI } from '../model/clasesPagare';
import { ResponseAuthAPI } from '../model/clasesPagare';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  public url = environment.URL_SERVICE + "/AuthAPIPinc";
  public headers = new HttpHeaders(
    {
      "Content-Type": "application/json;charset=UTF-8",
    }
  );

  constructor(private http: HttpClient) { }

  generarToken(requestAuthApi: RequestAuthAPI) {
    let path = this.url + "/AuthPinc";
    return this.http.post<ResponseAuthAPI>(path, requestAuthApi, { headers: this.headers });
  }

}
